
    (window.__NEXT_P=window.__NEXT_P||[]).push(["/marca", function() {
      var page = require("private-next-pages/marca.js")
      if(module.hot) {
        module.hot.accept("private-next-pages/marca.js", function() {
          if(!next.router.components["/marca"]) return
          var updatedPage = require("private-next-pages/marca.js")
          next.router.update("/marca", updatedPage.default || updatedPage)
        })
      }
      return { page: page.default || page }
    }]);
  